<div class="toast-holder" *ngIf="message" [ngClass]="{'toast-success':type === 'SUCCESS','toast-warning':type === 'WARNING', 'toast-danger':type === 'ERROR'}">
  <div class="icon"><i class="fa fa-check-circle" *ngIf="type === appConfig.Shared.Toast.Type.SUCCESS"></i><i class="fa fa-exclamation-circle" *ngIf="type === appConfig.Shared.Toast.Type.WARNING"></i><i class="fa fa-exclamation-circle" *ngIf="type === appConfig.Shared.Toast.Type.ERROR"></i></div>
  <div class="content">
    <div class="title">{{title | lowercase}}</div>
    <div data-testid="toast-message" class="message">{{message}}</div>
  </div>
  <div class="close fas fa-times" (click)="message = ''"></div>
</div>
